(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[405],{

/***/ 48312:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/",
      function () {
        return __webpack_require__(42977);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 87832:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "o": function() { return /* reexport */ StepContainer_StepContainer; }
});

// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(35944);
// EXTERNAL MODULE: ./node_modules/@mui/material/Container/Container.js + 1 modules
var Container = __webpack_require__(65582);
// EXTERNAL MODULE: ./node_modules/@mui/material/Box/Box.js
var Box = __webpack_require__(99226);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-intl/lib/src/components/useIntl.js
var useIntl = __webpack_require__(86896);
// EXTERNAL MODULE: ./src/constants/routes.constants.ts
var routes_constants = __webpack_require__(63624);
// EXTERNAL MODULE: ./src/components/@common/index.ts + 13 modules
var _common = __webpack_require__(92691);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/useTheme.js
var useTheme = __webpack_require__(2734);
// EXTERNAL MODULE: ./node_modules/@mui/material/useMediaQuery/useMediaQuery.js
var useMediaQuery = __webpack_require__(98396);
// EXTERNAL MODULE: ./node_modules/@mui/material/Stack/Stack.js + 1 modules
var Stack = __webpack_require__(51233);
// EXTERNAL MODULE: ./node_modules/@mui/material/Typography/Typography.js + 1 modules
var Typography = __webpack_require__(15861);
// EXTERNAL MODULE: ./node_modules/@mui/material/Stepper/Stepper.js + 3 modules
var Stepper = __webpack_require__(76624);
// EXTERNAL MODULE: ./node_modules/@mui/material/Step/Step.js + 1 modules
var Step = __webpack_require__(44472);
// EXTERNAL MODULE: ./node_modules/@mui/material/StepLabel/StepLabel.js + 3 modules
var StepLabel = __webpack_require__(89218);
;// CONCATENATED MODULE: ./src/components/@steps/StepIndicator/StepIndicator.tsx



var StepIndicator = function(param) {
    var activeStep = param.activeStep, steps = param.steps;
    var theme = (0,useTheme/* default */.Z)();
    var sm = (0,useMediaQuery/* default */.Z)(theme.breakpoints.down("sm"));
    return sm ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Stack/* default */.Z, {
        alignItems: "flex-end",
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Typography/* default */.Z, {
            variant: "body2",
            children: "".concat(steps[activeStep], " ").concat(activeStep + 1, "/").concat(steps.length)
        })
    }) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Stepper/* default */.Z, {
        activeStep: activeStep,
        children: steps.map(function(label) {
            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Step/* default */.Z, {
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StepLabel/* default */.Z, {
                    children: label
                })
            }, label);
        })
    });
};
/* harmony default export */ var StepIndicator_StepIndicator = (StepIndicator);

;// CONCATENATED MODULE: ./src/components/@steps/StepIndicator/index.ts


;// CONCATENATED MODULE: ./src/components/@steps/StepContainer/StepContainer.tsx







var steps = [
    {
        name: "language",
        route: routes_constants/* Routes.Root */.Z.Root
    },
    {
        name: "package",
        route: routes_constants/* Routes.Language */.Z.Language
    },
    {
        name: "student",
        route: routes_constants/* Routes.Student */.Z.Student
    },
    {
        name: "overview",
        route: routes_constants/* Routes.Checkout */.Z.Checkout
    },
    {
        name: "billing",
        route: routes_constants/* Routes.Checkout */.Z.Checkout
    }, 
];
var StepContainer = function(param) {
    var activeStep = param.activeStep, onBack = param.onBack, children = param.children;
    var intl = (0,useIntl/* default */.Z)();
    var handleBack = function() {
        if (onBack) onBack();
    };
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Container/* default */.Z, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box/* default */.Z, {
                display: {
                    xs: "flex",
                    md: "block"
                },
                justifyContent: {
                    xs: !!activeStep ? "space-between" : "flex-end"
                },
                alignItems: {
                    xs: "center"
                },
                mb: {
                    xs: 4,
                    md: 10
                },
                children: [
                    !!activeStep && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* default */.Z, {
                        mb: {
                            md: 4
                        },
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(_common/* BackButton */.xE, {
                            onClick: handleBack,
                            text: "label.previous"
                        })
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* default */.Z, {
                        mt: {
                            md: !!activeStep ? 0 : 12
                        },
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StepIndicator_StepIndicator, {
                            steps: steps.map(function(param) {
                                var name = param.name;
                                return intl.formatMessage({
                                    id: "order_flow.step.".concat(name, ".label")
                                });
                            }),
                            activeStep: activeStep
                        })
                    })
                ]
            }),
            children
        ]
    });
};
/* harmony default export */ var StepContainer_StepContainer = (StepContainer);

;// CONCATENATED MODULE: ./src/components/@steps/StepContainer/index.ts


;// CONCATENATED MODULE: ./src/components/@steps/index.ts



/***/ }),

/***/ 42977:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ pages; }
});

// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(35944);
// EXTERNAL MODULE: ./node_modules/@elgorditosalsero/react-gtm-hook/dist/react-gtm-hook.esm.js
var react_gtm_hook_esm = __webpack_require__(94904);
// EXTERNAL MODULE: ./node_modules/@mui/material/Box/Box.js
var Box = __webpack_require__(99226);
// EXTERNAL MODULE: ./node_modules/@mui/material/Typography/Typography.js + 1 modules
var Typography = __webpack_require__(15861);
// EXTERNAL MODULE: ./node_modules/@mui/material/Container/Container.js + 1 modules
var Container = __webpack_require__(65582);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/react-intl/lib/src/components/useIntl.js
var useIntl = __webpack_require__(86896);
// EXTERNAL MODULE: ./node_modules/react-intl/lib/src/components/message.js
var message = __webpack_require__(44012);
// EXTERNAL MODULE: ./src/constants/routes.constants.ts
var routes_constants = __webpack_require__(63624);
// EXTERNAL MODULE: ./src/hooks/index.ts + 2 modules
var hooks = __webpack_require__(31093);
// EXTERNAL MODULE: ./src/queries/index.ts + 30 modules
var queries = __webpack_require__(61320);
// EXTERNAL MODULE: ./src/components/@common/index.ts + 13 modules
var _common = __webpack_require__(92691);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@mui/material/Stack/Stack.js + 1 modules
var Stack = __webpack_require__(51233);
// EXTERNAL MODULE: ./node_modules/@mui/material/Chip/Chip.js + 2 modules
var Chip = __webpack_require__(87918);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/utils/test-id.utils.ts
var test_id_utils = __webpack_require__(32398);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/@emotion/react/dist/emotion-react.browser.esm.js
var emotion_react_browser_esm = __webpack_require__(70917);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/styled.js
var styled = __webpack_require__(90948);
// EXTERNAL MODULE: ./node_modules/@mui/material/Button/Button.js + 1 modules
var Button = __webpack_require__(42992);
// EXTERNAL MODULE: ./src/components/@icons/index.ts + 52 modules
var _icons = __webpack_require__(91177);
;// CONCATENATED MODULE: ./src/components/@languages/LanguageItem/LanguageItem.style.ts


function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  0% { \n    transform: scaleX(0.0);\n    -webkit-transform: scaleX(0.0);\n  }\n  25% { \n    transform: scaleX(0.25);\n    -webkit-transform: scaleX(0.25);\n  }\n  50% { \n    transform: scaleX(0.50);\n    -webkit-transform: scaleX(0.50);\n    \n  }\n  75% {\n    transform: scaleX(0.75);\n    -webkit-transform: scaleX(0.75);\n  }\n  100% {\n    transform: scaleX(1);\n    -webkit-transform: scaleX(1);\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 0;\n  height: 8px;\n  fill: ",
        ";\n  display: 'none';\n  ",
        " {\n    display: 'block';\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}



var grow = (0,emotion_react_browser_esm/* css */.iv)((0,emotion_react_browser_esm/* keyframes */.F4)(_templateObject()));
var Line = (0,styled/* default */.ZP)(_icons/* ImgScribbleLine */.OI)(_templateObject1(), function(param) {
    var theme = param.theme;
    return theme.palette.blue[200];
}, function(param) {
    var theme = param.theme;
    return theme.breakpoints.up("md");
});
var LanguageWrap = (0,styled/* default */.ZP)(Button/* default */.Z)(function(param) {
    var theme = param.theme;
    return (0,_define_property/* default */.Z)({
        padding: 0,
        textAlign: "left"
    }, theme.breakpoints.up("md"), {
        display: "inline-block",
        width: "-webkit-min-content",
        "&:hover": {
            ".line": {
                width: "100%",
                transformOrigin: "left",
                animation: "".concat(grow, " .1s ease-in-out 1"),
                "-webkit-animation-name": "".concat(grow),
                "-webkit-animation-duration": ".1s",
                "-webkit-animation-timing-function": "ease-in-out",
                "-webkit-animation-fill-mode": "forwards",
                "-webkit-animation-iteration-count": 1,
                "-webkit-animation-transform-origin": "left"
            }
        }
    });
});

;// CONCATENATED MODULE: ./src/components/@languages/LanguageItem/LanguageItem.tsx








var LanguageItem = function(param) {
    var item = param.item, onLanguageClick = param.onLanguageClick;
    var ref;
    var intl = (0,useIntl/* default */.Z)();
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Stack/* default */.Z, {
        direction: "row",
        alignItems: "center",
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(LanguageWrap, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                disableRipple: true,
                onClick: function() {
                    return onLanguageClick();
                }
            }, (0,test_id_utils/* generateTestId */.M)(item.title)), {
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Typography/* default */.Z, {
                        variant: "h2",
                        lineHeight: "50px",
                        children: item.title
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Line, {
                        className: "line",
                        preserveAspectRatio: "none"
                    })
                ]
            })),
            ((ref = item.metafield) === null || ref === void 0 ? void 0 : ref.value) === "true" && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Chip/* default */.Z, {
                sx: {
                    ml: 4
                },
                label: intl.formatMessage({
                    id: "label.new"
                }),
                color: "primary"
            })
        ]
    });
};
/* harmony default export */ var LanguageItem_LanguageItem = (LanguageItem);

;// CONCATENATED MODULE: ./src/components/@languages/LanguageItem/index.ts


// EXTERNAL MODULE: ./node_modules/@mui/material/Grid/Grid.js + 2 modules
var Grid = __webpack_require__(86886);
// EXTERNAL MODULE: ./node_modules/lodash/lodash.js
var lodash = __webpack_require__(96486);
;// CONCATENATED MODULE: ./src/components/@languages/LanguageList/Desktop.tsx





var Desktop = function(param) {
    var languages = param.languages, onLanguageClick = param.onLanguageClick;
    var sortedLanguages = function() {
        var sort = languages.sort(function(a, b) {
            return a.node.title.localeCompare(b.node.title);
        });
        return (0,lodash.chunk)(sort, Math.ceil(sort.length / 3));
    };
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Grid/* default */.ZP, {
        container: true,
        columnSpacing: 0,
        columnGap: 0,
        rowSpacing: 4,
        sx: {
            display: {
                xs: "none",
                md: "flex"
            }
        },
        children: sortedLanguages().map(function(group, index) {
            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Grid/* default */.ZP, {
                sx: {
                    pl: 0
                },
                item: true,
                md: 4,
                rowGap: 0,
                mb: 4,
                children: group.map(function(param) {
                    var node = param.node;
                    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* default */.Z, {
                        mb: {
                            md: 10
                        },
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LanguageItem_LanguageItem, {
                            item: node,
                            onLanguageClick: function() {
                                return onLanguageClick(node);
                            }
                        })
                    }, node.id);
                })
            }, index);
        })
    });
};
/* harmony default export */ var LanguageList_Desktop = (Desktop);

;// CONCATENATED MODULE: ./src/components/@languages/LanguageList/Mobile.tsx




var Mobile = function(param) {
    var languages = param.languages, onLanguageClick = param.onLanguageClick;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Grid/* default */.ZP, {
        container: true,
        sx: {
            display: {
                md: "none"
            }
        },
        children: languages.map(function(param) {
            var node = param.node;
            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Grid/* default */.ZP, {
                item: true,
                xs: 12,
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LanguageItem_LanguageItem, {
                    item: node,
                    onLanguageClick: function() {
                        return onLanguageClick(node);
                    }
                })
            }, node.id);
        })
    });
};
/* harmony default export */ var LanguageList_Mobile = (Mobile);

;// CONCATENATED MODULE: ./src/components/@languages/LanguageList/LanguageList.tsx




var LanguageList = function(param) {
    var onLanguageClick = param.onLanguageClick, languages = param.languages;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LanguageList_Mobile, {
                onLanguageClick: onLanguageClick,
                languages: languages
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LanguageList_Desktop, {
                onLanguageClick: onLanguageClick,
                languages: languages
            })
        ]
    });
};
/* harmony default export */ var LanguageList_LanguageList = (LanguageList);

;// CONCATENATED MODULE: ./src/components/@languages/LanguageList/index.ts


;// CONCATENATED MODULE: ./src/components/@languages/index.ts



// EXTERNAL MODULE: ./src/components/@steps/index.ts + 4 modules
var _steps = __webpack_require__(87832);
;// CONCATENATED MODULE: ./src/pages/index.tsx











var Home = function() {
    // prefetch user info when he's logged in
    (0,queries/* useProfile */.Un)();
    (0,queries/* useTeacher */.MJ)();
    var intl = (0,useIntl/* default */.Z)();
    var data = (0,queries/* useCollections */.bX)().data;
    var router = (0,next_router.useRouter)();
    var ref = (0,hooks/* useOrderFlow */.yo)(), updateOrder = ref.updateOrder, order = ref.order, setActiveStep = ref.setActiveStep;
    var sendToGTM = (0,react_gtm_hook_esm/* useGTMDispatch */.PN)();
    var handleLanguageClick = function(collection) {
        setActiveStep(order.activeStep + 1);
        if (!!collection.products.edges.length) {
            var ref;
            sendToGTM({
                event: "language_select",
                value: (ref = collection.products.edges[0].node.iso) === null || ref === void 0 ? void 0 : ref.value
            });
        }
        router.push({
            pathname: routes_constants/* Routes.Language */.Z.Language,
            query: {
                language: collection.handle
            }
        });
        updateOrder({
            collection: collection
        });
    };
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* default */.Z, {
                mb: 10,
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(_steps/* StepContainer */.o, {
                    activeStep: 0,
                    children: [
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Typography/* default */.Z, {
                            variant: "h3",
                            mb: {
                                xs: 2,
                                md: 10
                            },
                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                id: "order_flow.step.language.title"
                            })
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LanguageList_LanguageList, {
                            languages: (data === null || data === void 0 ? void 0 : data.edges) || [],
                            onLanguageClick: handleLanguageClick
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Container/* default */.Z, {
                sx: {
                    px: {
                        xs: 0
                    }
                },
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(_common/* InfoBox */.vD, {
                    text: "info_box.text.language",
                    link: {
                        text: intl.formatMessage({
                            id: "info_box.call_to_action"
                        }),
                        url: intl.formatMessage({
                            id: "info_box.link.language"
                        })
                    }
                })
            })
        ]
    });
};
var __N_SSG = true;
/* harmony default export */ var pages = (Home);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [662,463,934,774,888,179], function() { return __webpack_exec__(48312); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);